import Hls, { SubtitleTrackController } from 'hls.js';

var videoplayers = document.querySelectorAll('[data-behaviour="video-player"]');


var globalAudioToggle = document.querySelector('[data-behaviour="globalAudioToggle"]');
var globalAudioToggle2 = document.querySelector('[data-behaviour="globalAudioToggle2"]');
var globalAutoplayToggle = document.querySelector('[data-behaviour="globalAutoplayToggle"]');

window.globalAudioToggleState = false;

if (getCookie("autoplay") != null && getCookie("autoplay") != "") {
    if(getCookie("autoplay") == "true") {
        globalAutoplayToggle.checked = true;
        globalAutoplayToggle.classList.add('checked');
    } else {
        globalAutoplayToggle.checked = false;
        globalAutoplayToggle.classList.remove('checked');
    }
    window.globalAutoplayToggleState = getCookie("autoplay") == "true";
} else {
    window.globalAutoplayToggleState = true;
}
window.globalVolume = 0.5;

// Check if HLS.js is supported
if (Hls.isSupported()) {
    if (videoplayers.length == 0) {
        const globalmute = document.querySelector('.section--GlobalMuteButton');
        globalmute.classList.add('hidden');
    }

    videoplayers.forEach(function (videoplayer) {
        var video = videoplayer.querySelector('video');
        var isManuallyPaused = false;
        video.currentTime = 0.001;
        videoplayer.classList.add('videoplayer--paused');
        video.muted = true;

        var videoCover = null;
        if (videoplayer.dataset.cover == true) {
            videoCover = videoplayer.querySelector('.video-cover');
        }

        if (!video) {
            console.error('Video element not found');
        }

        var hls = new Hls();

        // MEDIA_ATTACHED event is fired by hls object once MediaSource is ready
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
            console.log('video and hls.js are now bound together !');
        });
        hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
            console.log(
                'manifest loaded, found ' + data.levels.length + ' quality level',
            );
        });
        hls.loadSource(video.getAttribute('data-src'));

        hls.attachMedia(video);
        console.log('video loaded');

        window.addEventListener('scroll', function () {
            if (globalAutoplayToggleState) {
                //Play Video when in viewport
                let videoTop = video.getBoundingClientRect().top + window.scrollY;
                let videoBottom = videoTop + video.clientHeight;
                let windowTop = window.scrollY;
                let windowBottom = windowTop + window.innerHeight;
                if (videoTop < windowBottom && videoBottom > windowTop) {
                    hls.startLoad();
                } else {
                    hls.stopLoad();
                }
                // Pause video when not in viewport
                if (videoTop < windowBottom && videoBottom > windowTop) {
                    if (!isManuallyPaused && videoplayer.dataset.cover == false) {
                        video.play();
                        videoplayer.classList.remove('videoplayer--paused');
                    }
                } else {
                    video.pause();
                    videoplayer.classList.add('videoplayer--paused');
                }
            }
        });


        //Add Actions to Player
        var pauseButton = videoplayer.querySelector('[data-behaviour="video-pause"]');
        if (pauseButton) {
            pauseButton.addEventListener('click', function () {
                if (video.paused) {
                    video.play();
                    isManuallyPaused = false;
                    videoplayer.classList.remove('videoplayer--paused');
                    pauseButton.classList.remove('paused');
                    if(videoCover) {
                        videoCover.classList.add('hidden');
                    }
                } else {
                    video.pause();
                    isManuallyPaused = true;
                    videoplayer.classList.add('videoplayer--paused');
                    pauseButton.classList.add('paused');
                    if(videoCover) {
                        videoCover.classList.remove('hidden');
                    }
                }
            });

            video.addEventListener('play', function () {
                pauseButton.classList.remove('paused');
                videoplayer.classList.remove('videoplayer--paused');
            }
            );
            video.addEventListener('pause', function () {
                pauseButton.classList.add('paused');
                videoplayer.classList.add('videoplayer--paused');
            });
            video.addEventListener('ended', function () {
                pauseButton.classList.add('paused');
            });

        }

        videoplayer.addEventListener('click', function (e) {
            if (e.target.closest('[data-behaviour="video-pause"]')
                || e.target.closest('[data-behaviour="video-mute"]')
                || e.target.closest('[data-behaviour="video-captionstoggle"]')
                || e.target.closest('[data-behaviour="video-volume"]')
                || e.target.closest('[data-behaviour="video-progress"]')) {
                return;
            }
            if (video.paused) {
                video.play();
                isManuallyPaused = false;
                videoplayer.classList.remove('videoplayer--paused');
                pauseButton.classList.remove('paused');
            } else {
                video.pause();
                isManuallyPaused = true;
                videoplayer.classList.add('videoplayer--paused');
                pauseButton.classList.add('paused');
            }
        });

        var volumeSlider = videoplayer.querySelector('[data-behaviour="video-volume"]');
        if (volumeSlider) {
            volumeSlider.addEventListener('input', function () {
                window.globalVolume = volumeSlider.value;

                videoplayers.forEach(function (videoplayer) {
                    var video = videoplayer.querySelector('video');
                    var muteButton = videoplayer.querySelector('[data-behaviour="video-mute"]');
                    var volumeSlider = videoplayer.querySelector('[data-behaviour="video-volume"]');

                    if (!video || !muteButton) {
                        console.error('Video or mute element not found');
                    }

                    video.volume = window.globalVolume;
                    volumeSlider.value = window.globalVolume;

                    if (video.volume === 0) {
                        muteButton.classList.add('muted');
                    } else {
                        muteButton.classList.remove('muted');
                    }

                    if (video.volume === 0) {
                        video.muted = true;
                    } else {
                        video.muted = false;
                    }
                });
            });
        }

        var muteButton = videoplayer.querySelector('[data-behaviour="video-mute"]');
        if (muteButton) {
            muteButton.addEventListener('click', function () {
                if (video.muted) {
                    video.muted = false;
                    muteButton.classList.remove('muted');
                    if (video.volume === 0) {
                        video.volume = 0.2;
                    }
                    volumeSlider.value = video.volume;
                } else {
                    video.muted = true;
                    muteButton.classList.add('muted');
                    volumeSlider.value = 0;
                }
            });
        }

        var progressBar = videoplayer.querySelector('[data-behaviour="video-progress"]');
        if (progressBar) {
            progressBar.addEventListener('input', function () {
                var seekTime = (progressBar.value) * video.duration;
                video.currentTime = seekTime;

                if(video.paused && !isManuallyPaused) {
                    video.play();
                    isManuallyPaused = false;
                    pauseButton.classList.remove('paused');
                }
            });

            const progressText = videoplayer.querySelector('[data-behaviour="video-progress-time"]');

            video.addEventListener('timeupdate', function () {
                progressBar.value = video.currentTime / video.duration;
                var minutes = Math.floor(video.currentTime / 60);
                var seconds = Math.floor(video.currentTime % 60);
                var durationMinutes = Math.floor(video.duration / 60);
                var durationSeconds = Math.floor(video.duration % 60);
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                if (durationSeconds < 10) {
                    durationSeconds = '0' + durationSeconds;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                if (durationMinutes < 10) {
                    durationMinutes = '0' + durationMinutes;
                }
                progressText.innerHTML = minutes + ':' + seconds + ' / ' + durationMinutes + ':' + durationSeconds;
            });
            video.addEventListener('loadedmetadata', function () {
                progressBar.max = 1;
            });
        }

        video.addEventListener("loadeddata", () => {
            if (video.getAttribute("data-vttsrc") != undefined) {
                const vttSrc = video.getAttribute("data-vttsrc").replace(/\.vtt$/, ".vtt");
                const trackEl = document.createElement("track");
                trackEl.setAttribute("kind", "captions");
                trackEl.setAttribute("src", vttSrc);
                video.appendChild(trackEl);

                trackEl.track.mode = "showing"; // Enable the track with "hidden", or "showing" if using native captions display.
            }
        });
    });
}
// HLS.js is not supported on platforms that do not have Media Source
// Extensions (MSE) enabled.
//
// When the browser has built-in HLS support (check using `canPlayType`),
// we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
// element through the `src` property. This is using the built-in support
// of the plain video element, without using HLS.js.
else if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = videoSrc;
}

if (globalAudioToggle) {
    globalAudioToggle.addEventListener('click', function () {
        window.globalAudioToggleState = globalAudioToggle.checked;
        document.cookie = "globalaudio=" + window.globalAudioToggleState;

        if (window.globalAudioToggleState) {
            globalAudioToggle2.classList.add('muted');
        } else {
            globalAudioToggle2.classList.remove('muted');
        }

        videoplayers.forEach(function (videoplayer) {
            var video = videoplayer.querySelector('video');
            var muteButton = videoplayer.querySelector('[data-behaviour="video-mute"]');
            var volumeSlider = videoplayer.querySelector('[data-behaviour="video-volume"]');

            if (!video || !muteButton) {
                console.error('Video element not found');
            }

            if (window.globalAudioToggleState) {
                video.muted = false;
                volumeSlider.value = video.volume;
                muteButton.classList.remove('muted');
            } else {
                video.muted = true;
                volumeSlider.value = 0;
                muteButton.classList.add('muted');
            }
        });
    });
}

if (globalAudioToggle2) {
    globalAudioToggle2.addEventListener('click', function () {
        window.globalAudioToggleState = !window.globalAudioToggleState;
        globalAudioToggle2.classList.toggle('muted');
        globalAudioToggle.checked = window.globalAudioToggleState;
        document.cookie = "globalaudio=" + window.globalAudioToggleState;

        videoplayers.forEach(function (videoplayer) {
            var video = videoplayer.querySelector('video');
            var muteButton = videoplayer.querySelector('[data-behaviour="video-mute"]');
            var volumeSlider = videoplayer.querySelector('[data-behaviour="video-volume"]');

            if (!video || !muteButton) {
                console.error('Video element not found');
            }

            if (window.globalAudioToggleState) {
                video.muted = false;
                volumeSlider.value = video.volume;
                muteButton.classList.remove('muted');
            } else {
                video.muted = true;
                volumeSlider.value = 0;
                muteButton.classList.add('muted');
            }
        });
    });
}

if (globalAutoplayToggle) {
    globalAutoplayToggle.addEventListener('click', function () {
        window.globalAutoplayToggleState = globalAutoplayToggle.checked;
        document.cookie = "autoplay=" + window.globalAutoplayToggleState;
    });
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
